<template>
  <svg
    width="60"
    height="28"
    viewBox="0 0 60 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.0637 23.0974L21.5071 23.0974L24.3549 5.59118L28.912 5.59118L26.0637 23.0974ZM17.6738 5.59118L13.3297 17.6321L12.8156 15.0392L12.8161 15.0401L11.2829 7.16741C11.2829 7.16741 11.0975 5.59118 9.12137 5.59118L1.93975 5.59118L1.85548 5.8876C1.85548 5.8876 4.05164 6.34464 6.62185 7.88856L10.5806 23.0979L15.3283 23.0979L22.5778 5.59118L17.6738 5.59118ZM53.514 23.0974L57.6979 23.0974L54.05 5.59071L50.3871 5.59071C48.6956 5.59071 48.2837 6.89534 48.2837 6.89534L41.4878 23.0974L46.2378 23.0974L47.1877 20.497L52.9803 20.497L53.514 23.0974ZM48.5 16.9048L50.8941 10.3536L52.241 16.9048L48.5 16.9048ZM41.8441 9.80102L42.4944 6.04166C42.4944 6.04166 40.4878 5.27837 38.3961 5.27837C36.1348 5.27837 30.765 6.26691 30.765 11.0738C30.765 15.5965 37.0674 15.6527 37.0674 18.0282C37.0674 20.4038 31.4143 19.9782 29.5487 18.4801L28.8713 22.4109C28.8713 22.4109 30.9059 23.3994 34.0145 23.3994C37.1241 23.3994 41.8151 21.789 41.8151 17.4059C41.8151 12.8542 35.456 12.4304 35.456 10.4515C35.4565 8.47204 39.8942 8.72632 41.8441 9.80102Z"
      fill="#979797"
      fill-opacity="0.2"
    />
    <path
      d="M12.8161 15.0401L11.2829 7.16741C11.2829 7.16741 11.0975 5.59118 9.12137 5.59118L1.93975 5.59118L1.85548 5.8876C1.85548 5.8876 5.30725 6.6028 8.61809 9.2837C11.7838 11.8461 12.8161 15.0401 12.8161 15.0401Z"
      fill="#979797"
      fill-opacity="0.2"
    />
  </svg>
</template>
